// extracted by mini-css-extract-plugin
module.exports = {"container":"Descriptions_container__y_nuc","iconContainer":"Descriptions_iconContainer__uQbxa","icon":"Descriptions_icon___RWGI"};